import { useContext } from "react";
import { Navigate } from "react-router";

import { AuthContext } from "../providers/auth";

export const CheckAuthenticatedUser = ({ children }) => {
  const user = useContext(AuthContext);
  return user ? { ...children } : <Navigate to="/auth/login" />;
};
